// DocumentTreatmentInformation.js — Extracted from Document.js
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/en";
import ReadOnlyDocumentField from "./ReadOnlyDocumentField";

const DocumentTreatmentInformation = ({
  documentData,
  treatmentStartDateValue,
  setTreatmentStartDateValue,
  treatmentEndDateValue,
  setTreatmentEndDateValue,
  handleDatePickerSave,
  isEditingTreatmentSetting,
  setIsEditingTreatmentSetting,
  treatmentSetting,
  setTreatmentSetting,
  handleTreatmentInfoSave,
  isEditingTreatingClinician,
  setIsEditingTreatingClinician,
  treatingClinician,
  setTreatingClinician,
  isEditable = true,
}) => {
  if (!isEditable) {
    return (
      <div className="standard-container">
        <div className="datetime-header datetime-row">
          <ReadOnlyDocumentField label="Start Date" value={treatmentStartDateValue?.isValid() ? treatmentStartDateValue.format("MM/DD/YYYY") : null} />
          <ReadOnlyDocumentField label="End Date" value={treatmentEndDateValue?.isValid() ? treatmentEndDateValue.format("MM/DD/YYYY") : null} />
          <ReadOnlyDocumentField label="Treatment Setting" value={documentData.treatmentSetting} />
          <ReadOnlyDocumentField label="Treating Clinician" value={documentData.treatingClinician} />
        </div>
      </div>
    );
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <div className="standard-container">
        <div className="datetime-header">
          <div className="document-date">
            <DatePicker
              label="Start Date"
              value={treatmentStartDateValue}
              onChange={(newValue) => {
                setTreatmentStartDateValue(newValue);
                if (newValue && newValue.isValid()) {
                  handleDatePickerSave(newValue, "startDate");
                }
              }}
              slotProps={{
                textField: { size: "small" },
              }}
            />
          </div>

          <div className="document-date">
            <DatePicker
              label="End Date"
              value={treatmentEndDateValue}
              onChange={(newValue) => {
                setTreatmentEndDateValue(newValue);
                if (newValue && newValue.isValid()) {
                  handleDatePickerSave(newValue, "endDate");
                }
              }}
              slotProps={{
                textField: { size: "small" },
              }}
            />
          </div>

          <div className="document-therapy">
            <small>Treatment Setting:</small>
            {isEditingTreatmentSetting ? (
              <input type="text" value={treatmentSetting} onChange={(e) => setTreatmentSetting(e.target.value)} onBlur={() => handleTreatmentInfoSave("treatmentSetting", treatmentSetting)} autoFocus className="document-therapy-input" />
            ) : (
              <span
                onClick={() => {
                  setIsEditingTreatmentSetting(true);
                  setTreatmentSetting(documentData.treatmentSetting || "");
                }}>
                {documentData.treatmentSetting || "---"}
              </span>
            )}
          </div>

          <div className="document-therapy">
            <small>Treating Clinician:</small>
            {isEditingTreatingClinician ? (
              <input type="text" value={treatingClinician} onChange={(e) => setTreatingClinician(e.target.value)} onBlur={() => handleTreatmentInfoSave("treatingClinician", treatingClinician)} autoFocus className="document-therapy-input" />
            ) : (
              <span
                onClick={() => {
                  setIsEditingTreatingClinician(true);
                  setTreatingClinician(documentData.treatingClinician || "");
                }}>
                {documentData.treatingClinician || "---"}
              </span>
            )}
          </div>
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default DocumentTreatmentInformation;
